import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get Incident
export const getIncident = createAsyncThunk("incident/get-incident", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/operations/app/v1/get-incident`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        return response;
    } catch (error) {
        console.error('Error fetching Incident- ', error);
        throw error;
    }
})


